import { axiosEstraFormsInstance } from 'app/utils/axiosConfig'

import { estraFormsEndpoints } from './endpoints'

export type FormKind =
  | 'contatti'
  | 'caldaia'
  | 'newsletter'
  | 'wall-box'
  | 'partner'
  | 'ecup'
  | 'convenzioni'
  | 'convenzioniAzienda'
  | 'climaImprese'
  | 'condomini'

type SendEstraFormPayloadData = {
  nome?: string
  cognome?: string
  denominazione?: string
  cf?: string
  azienda?: string
  tipo_telefono?: 'default' | 'mobile'
  numero_telefono?: string
  numero_cellulare?: string
  codice_cliente?: string
  tipo_cliente?: string
  acc_privacy: 'true' | 'false'
  indirizzo?: string
  citta?: string
  provincia?: string
  civico?: string
  cap?: string
  agenzia?: string
  proprietarioagenzia?: string
  nome_agenzia?: string
  numero_agenzia?: string
  tipo_agenzia?: string
  profilo_agente?: string
  cv_agente_link?: string
  proprietariocaldaia?: string
  consenso_mktg?: 'true' | 'false'
  consenso_terzi?: 'true' | 'false'
}

type SendEstraFormPayloadContact = {
  periodo?: string
  sm: string
  motivo: string
  metodo_ricontatto?: string
  desc_richiesta?: string
  provenienza_id?: string
  note?: string
  altre_info_1?: string
  altre_info_2?: string
  altre_info_3?: string
  altre_info_4?: string
  altre_info_5?: string
}

export type SendEstraFormPayload = {
  recaptcha_token: string
  kind: FormKind
  data: {
    email: string
    anagrafica: SendEstraFormPayloadData
    contatto: SendEstraFormPayloadContact
  }
}

export type SendEstraFormResponse = {
  invio_email_cliente: boolean | null
  invio_email_interna: boolean | null
  invio_registrazine_newsletter: boolean | null
  inserimento_contatto: boolean
  contatto_neta: boolean | null
  descrizione_esito: string
  tipo_errore: string
}

export const sendEstraForm = async (
  data: SendEstraFormPayload
): Promise<SendEstraFormResponse> => {
  return axiosEstraFormsInstance
    .post<SendEstraFormResponse>(estraFormsEndpoints.forms, data)
    .then(({ data }) => {
      return data
    })
}

export type SendNewsletterPayload = Omit<
  SendEstraFormPayload,
  'data' | 'kind'
> & {
  kind: 'newsletter'
  data: Pick<SendEstraFormPayload['data'], 'email'> & {
    anagrafica: Required<Pick<SendEstraFormPayloadData, 'acc_privacy'>> & {
      denominazione: 'Newsletter'
    }
    contatto: {
      sm: '9'
      motivo: '11'
    }
  }
}

export const sendNewsletter = async (
  data: SendNewsletterPayload
): Promise<SendEstraFormResponse> => {
  return sendEstraForm(data)
}
